import React, { Component } from 'react'
import {Button, Icon, Popup, Modal, Dropdown} from 'semantic-ui-react'
import {yearOptions, quarterOptions} from '../../reports/options'

class CadExtraFilters extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      year: [],
      quarter: []
    }
  }

  openModal = () => {
    this.setState({open: true})
  }

  closeModal = () => {
    this.setState({open: false})
  }

  fieldOnChange = (event, {value, name}) => {
    let newState = {}
    newState[name] = value.sort()
    this.setState(newState)
  }

  clearFilters = () => {
    this.setState({year: [], quarter: []})
  }

  render() {
    let {open, year, quarter} = this.state
    let inUse = year.length > 0 || quarter.length > 0

    return (
      <div style={{float: 'right'}}>
        <Modal onClose={this.closeModal} open={open} closeIcon>
          <Modal.Header>
            Extra Filters
            {
              inUse
              ?
              <a onClick={this.clearFilters} style={{textDecoration: 'none', float: 'right', fontSize: '12px', cursor: 'pointer'}}>clear filters</a>
              :
              null
            }
          </Modal.Header>
          <Modal.Content style={{textAlign: 'center'}}>
            <Dropdown placeholder='Best Seller Year' fluid multiple selection search
              options={yearOptions} onChange={this.fieldOnChange} name='year' value={year}
              style={{width: '45%', display: 'inline-block'}}
            />

            <Dropdown placeholder='Best Seller Quarter' fluid multiple selection search
              options={quarterOptions} onChange={this.fieldOnChange} name='quarter' value={quarter}
              style={{width: '45%', display: 'inline-block', marginLeft: '4%'}}
            />
          </Modal.Content>
          <Modal.Actions>
            <Button
              content="Done"
              labelPosition='right'
              icon='checkmark'
              onClick={this.closeModal}
              positive
            />
          </Modal.Actions>
        </Modal>
        <Popup position='top right' content='Show extra filters'
          trigger={
            inUse
            ?
            <Button icon primary id="showFilters" onClick={this.openModal}><Icon name='filter'/></Button>
            :
            <Button icon basic id="showFilters" onClick={this.openModal}><Icon name='filter'/></Button>
          }
        />
      </div>
    )
  }
}

export default CadExtraFilters
